// ── useAuthentication.js ──────────────────────────────────────────────────────
// Handles all auth token/user checks from localStorage

const useAuthentication = () => {
  const checkAuthentication = () => {
    const authToken   = localStorage.getItem('authToken');
    const token       = localStorage.getItem('token');
    const accessToken = localStorage.getItem('access_token');
    const userString  = localStorage.getItem('user');
    const userData    = localStorage.getItem('userData');
    const hasToken    = !!(authToken || token || accessToken);
    const hasUserData = !!(userString || userData);
    return {
      isAuthenticated: hasToken && hasUserData,
      token: authToken || token || accessToken,
      user: userString || userData,
    };
  };

  return { checkAuthentication };
};

export default useAuthentication;
